import React from 'react';
import {Row, Col, Container, Image} from 'react-bootstrap';

function Display() {
    return <Container className='displaymenu'>
    <Row>
        <Col xs={3}>
            <Image src='' className='displaymenu-image' id='' alt=''/>
        </Col>
        <Col xs={3}>
            <Image src='' className='displaymenu-image' id='' alt=''/>
        </Col>
        <Col xs={3}>
            <Image src='' className='displaymenu-image' id='' alt=''/>
        </Col>
        <Col xs={3}>
            <Image src='' className='displaymenu-image' id='' alt=''/>
        </Col>
    </Row>
    <Row>
        <Col xs={3}>
            <Image src='' className='displaymenu-image' id='' alt=''/>
        </Col>
        <Col xs={3}>
            <Image src='' className='displaymenu-image' id='' alt=''/>
        </Col>
        <Col xs={3}>
            <Image src='' className='displaymenu-image' id='' alt=''/>
        </Col>
        <Col xs={3}>
            <Image src='' className='displaymenu-image' id='' alt=''/>
        </Col>
    </Row>
    </Container>
}

export default Display;